import services from './_services'

export default {
  getOrganizations_v2 (params) {
    return services.getWithParams(process.env.ROOT_API + '/v2/organizations/', params)
  },
  getOrganizationsSearchOptions_v2 () {
    return services.get(process.env.ROOT_API + '/v2/organizations/search/options')
  },
  getOrganizationsSearch_v2 (params) {
    return services.getWithParams(process.env.ROOT_API + '/v2/organizations/search', params)
  },
  getExportOfOrganizationsSearch_v2 (searchQuery) {
    return services.enqueueCall(process.env.ROOT_API + '/v2/organizations/search/export', searchQuery)
  },
  getOrganizationRankings (params) {
    return services.getWithParams(process.env.ROOT_API + '/v2/organizations/rankings', params)
  },
  searchOrganizations (searchQuery) {
    return services.enqueueCall(process.env.ROOT_API + '/organizations/results/', searchQuery)
  },
  getOrganization (accountID) {
    return services.enqueueCall(process.env.ROOT_API + '/organizations/' + accountID + '/')
  },
  refreshOrganizationData (accountID) {
    return services.enqueueJob(process.env.ROOT_API + '/organizations/' + accountID + '/refresh', {})
  },
  uploadOrganizationLogo (accountId, file) {
    return services.upload(process.env.ROOT_API + '/organizations/' + accountId + '/upload', file)
  },
  getTagsOfOrganization (accountID) {
    return services.get(process.env.ROOT_API + '/organizations/' + accountID + '/tag/')
  }
}



// WEBPACK FOOTER //
// ./src/api/organizations.js